import roles, { Role } from '../constants/roles';

export const isBooker = (role: Role) => role === roles.booker;
export const isPrimaryUser = (role: Role) => role === roles.primaryUser;
export const isBillPayer = (role: Role) => role === roles.billPayer;
export const notBooker = (role: Role) => !isBooker(role);
export const isCustomer = (role: Role) =>
  isBooker(role) || isBillPayer(role) || isPrimaryUser(role);
